import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import useUser from '../../../../hook/data/useUser';
import { ImageLocation } from '../../../../utils/URLUtils';
import styles from './LogoSection.module.scss';

const LogoSection: React.FC = () => {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const { isProUser } = useUser();

    return (
        <div className={styles.logoSection}>
            <img className={styles.logo} src={ImageLocation('logo.webp')} alt={t('Logo')} />
            {!isProUser() && (
                <button
                    className={styles.proButton}
                    dir={i18n.dir()}
                    onClick={() => navigate('/membership')}
                >
                    {t('Get WordUp Pro')}
                </button>
            )}
        </div>
    );
};

export default LogoSection; 